import { css as _css } from "@emotion/core";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import buildUrl from './util/build-url';
import * as styles from './style/page-button.style';
import { desktopOnly } from './style/global';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PageButton = _ref => {
  var pageNumber = _ref.pageNumber,
    currentPage = _ref.currentPage,
    hideIfMobile = _ref.hideIfMobile,
    onPageChange = _ref.onPageChange,
    urlTemplate = _ref.urlTemplate,
    baseId = _ref.baseId;
  var isCurrentPage = pageNumber === currentPage;
  var selectedPageId = baseId && isCurrentPage ? "".concat(baseId, "-paginator-page-selected") : undefined;
  var href = buildUrl(urlTemplate, pageNumber);
  var clickProps = isCurrentPage ? {} : {
    onClick: event => onPageChange(event, pageNumber, href),
    href
  };
  var Tag = isCurrentPage ? 'span' : 'a';
  return ___EmotionJSX(Tag, _extends({
    "data-testid": "paginator-page-button",
    css: /*#__PURE__*/_css([styles.pageButton, isCurrentPage && styles.currentPage, hideIfMobile && !isCurrentPage && desktopOnly]),
    id: selectedPageId
  }, clickProps), pageNumber);
};
export default PageButton;